/* Jubi · Cloudflare Turnstile helper (Sep 6 2026; on-demand only since Sep 18 2026)
   One fresh, single-use token per upload for the photo/document upload Worker. NOTHING runs on page load: Cloudflare's
   script loads and the check runs only when a visitor actually attaches a file (the first token() call). The widget is
   invisible unless Cloudflare decides that visitor needs a check, and then it shows INSIDE the form, directly under the
   upload box the caller passes in, never pinned over the page. Site key is public by design.
   Usage: JubiTurnstile.token(uploadBoxEl).then(function (tok) { headers['X-Turnstile-Token'] = tok; }) — tok is null on
   failure, in which case the upload is still attempted and the Worker decides.
   Do NOT reintroduce a page-load pre-warm: the Rug Plan modal is rendered from layout/theme.liquid, so anything keyed
   off its markup runs on every page of the site. */
(function () {
  var SITE_KEY = '0x4AAAAAAEqzL2pPDpwUp1Ky';
  var scriptP = null, widgetId = null, waiter = null, chain = Promise.resolve();
  var box = null, mountedAt = null, extend = null;

  function loadScript() {
    if (window.turnstile) return Promise.resolve();
    if (scriptP) return scriptP;
    scriptP = new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      s.async = true; s.defer = true;
      s.onload = res; s.onerror = function () { scriptP = null; rej(new Error('turnstile')); };
      document.head.appendChild(s);
    });
    return scriptP;
  }
  function settle(tok) { var w = waiter; waiter = null; if (w) w(tok); }
  function ensureWidget(anchor) {
    if (widgetId !== null && mountedAt === anchor) return;
    /* a different form on the same page (modal vs. page section): move the widget to where the visitor is working */
    if (widgetId !== null) { try { window.turnstile.remove(widgetId); } catch (e) {} widgetId = null; }
    if (box && box.parentNode) box.parentNode.removeChild(box);
    box = document.createElement('div');
    box.className = 'jubi-turnstile';
    if (anchor && anchor.parentNode) {
      /* in the form's flow, under the upload box; takes no space while the widget stays invisible */
      box.style.cssText = 'display:block;width:100%;line-height:0';
      anchor.parentNode.insertBefore(box, anchor.nextSibling);
    } else {
      /* no anchor given: keep it out of the page rather than floating over it */
      box.style.cssText = 'position:absolute;left:-9999px;top:0';
      document.body.appendChild(box);
    }
    mountedAt = anchor || null;
    widgetId = window.turnstile.render(box, {
      sitekey: SITE_KEY,
      appearance: 'interaction-only',
      execution: 'execute',
      size: 'flexible',
      callback: function (tok) { settle(tok); },
      'error-callback': function () { settle(null); },
      'timeout-callback': function () { settle(null); },
      'expired-callback': function () {},
      /* a visible check is about to show: give it breathing room and give the visitor time to tick it */
      'before-interactive-callback': function () { box.style.margin = '12px 0 4px'; if (extend) extend(); },
      'after-interactive-callback': function () { box.style.margin = '0'; }
    });
  }
  function oneToken(anchor, timeoutMs) {
    return loadScript().then(function () {
      ensureWidget(anchor);
      return new Promise(function (res) {
        var done = false;
        function giveUp() { if (!done) { done = true; waiter = null; extend = null; res(null); } }
        var t = setTimeout(giveUp, timeoutMs || 15000);
        /* invisible checks finish in a second or two; a visitor asked to tick the box gets two minutes */
        extend = function () { clearTimeout(t); t = setTimeout(giveUp, 120000); };
        waiter = function (tok) { if (done) return; done = true; clearTimeout(t); extend = null; res(tok); };
        try { window.turnstile.reset(widgetId); window.turnstile.execute(widgetId); }
        catch (e) { if (!done) { done = true; clearTimeout(t); waiter = null; extend = null; res(null); } }
      });
    }).catch(function () { return null; });
  }
  // serialise: tokens are single-use, so parallel uploads each wait their turn
  function token(anchor, timeoutMs) {
    var p = chain.then(function () { return oneToken(anchor, timeoutMs); });
    chain = p.catch(function () {});
    return p;
  }
  window.JubiTurnstile = { token: token };
})();
